import { props as apiProps, events as apiEvents } from '../mobile-general-form-api/props';
import { $http } from '../component-base/xhr';

export const props = () => {
    const apiPropsArr = apiProps();
    return [
        {
            key: 'infoKey',
            label: '获取info',
            type: 'info-select',
            props: {
                async remoteMethod(param) {
                    const { data } = await $http.post('/v3/csc/api/info/core/list', {
                        ...param,
                        count: 30,
                    });
                    const optionList = [];
                    data.data.data.forEach(({ id, name, key }) => {
                        optionList.push({
                            name,
                            id,
                            key,
                        });
                    });
                    return optionList;
                },
            },
        },
        ...apiPropsArr,
    ];
};

export const init = () => ({
    url: '/rest/csc/collect/info/get',
    method: 'post',
    infoKey: '',
    payloadSources: [],
    omitGlobalParams: false,
    config: {},
    preProcessCode: '',
    postProcessCode: '',
    pickKey: 'data',
});

export const name = '关联info';

export const component = 'mobile-general-form-api-info';

export const events = apiEvents;
